import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useAdmissionsService } from '../../../../apis/admissions/useAdmissionsService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TStudentFeeSummary } from '../../../../apis/admissions/adminssionFees.interfaces';

type TQueryError = IFHError<{ message: string }>;
type TStudentFeesQueryOptions = Omit<
  UseQueryOptions<TStudentFeeSummary[], TQueryError>,
  'queryKey' | 'queryFn'
>;

export const getStudentFeesKey = 'get-student-fees-list';

export const useStudentFeesHook = (
  params: TPaginationParams,
  options?: TStudentFeesQueryOptions
): UseQueryResult<TStudentFeeSummary[], TQueryError> => {
  const { getStudentFees } = useAdmissionsService();

  const queryKey = [getStudentFeesKey];

  return useQuery<TStudentFeeSummary[], TQueryError>({
    queryKey,
    queryFn: () => getStudentFees(),
    enabled: false,
    ...options,
  });
};
